export const DATE_FORMAT = {
    TIME: 'HH:mm',
    DATE: 'Y-MM-DD',
    TZ: ''
};
